import { Image } from '@/features/shared/elements/Image/NextImage'
import { BotOnly } from '@/features/shared/components/BotOnly'
import { getNormalizedPromoUrl } from '@/features/cms/components/CMS/utils/getNormalizedPromoUrl'
import { type ShoppingStoreDetails } from '@/features/shop/services/ShoppingStore/types'
import { type HeroCardData } from '@/features/cms/components/CMS/types'
import { getPromotionFromData } from '@/features/cms/components/CMS/utils/promotion'

type Props = {
  heroCardData: HeroCardData
  deliveryStores: ShoppingStoreDetails[] | undefined
}
export const BotOnlyHeroCard = ({ heroCardData, deliveryStores }: Props) => {
  const storeCards = heroCardData.data.store_cards
  if (!storeCards?.length) return null

  const promotion = getPromotionFromData(heroCardData)
  const { normalizedUrl } = getNormalizedPromoUrl({
    destinationUrl: heroCardData.data.link.url,
    availableStoreIds: promotion.available_store_ids ?? undefined,
    deliveryStores,
  })

  return (
    <BotOnly>
      <p>Available at</p>
      <ul>
        {storeCards.map((store) => (
          <li key={store.data.retailer_id}>
            <a href={normalizedUrl}>
              {store.data.name}
              <Image
                src={store.data.circular_logo?.src ?? store.data.logo.src}
                alt={store.data.name}
                width={100}
                height={100}
              />
            </a>
          </li>
        ))}
      </ul>
    </BotOnly>
  )
}
